import merge from 'lodash.merge';
import { useMemo } from 'react';
import { LocaleProvider as SnackLocaleProvider, useLocale as snackUseLocale } from '@snack-uikit/locale';
import { UIKIT_PRODUCT_LOCALES } from '../locales';
import { resolveCommonTranslations } from '../locales/resolveCommonTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
export function LocaleProvider(_ref) {
  var children = _ref.children,
    overrideLocales = _ref.overrideLocales,
    lang = _ref.lang,
    _ref$fallbackLang = _ref.fallbackLang,
    fallbackLang = _ref$fallbackLang === void 0 ? 'ru-RU' : _ref$fallbackLang,
    additionalTranslationsResources = _ref.additionalTranslationsResources;
  var memoizedLocales = useMemo(function () {
    return merge({}, UIKIT_PRODUCT_LOCALES, /* Тип обязывает прокинуть доп. переводы, но если это не сделать, ничего не упадет */
    additionalTranslationsResources ? resolveCommonTranslations(additionalTranslationsResources) : {}, overrideLocales);
  }, [overrideLocales, additionalTranslationsResources]);
  return /*#__PURE__*/_jsx(SnackLocaleProvider, {
    lang: lang,
    overrideLocales: memoizedLocales,
    fallbackLang: fallbackLang,
    children: children
  });
}
export function useLocale(componentName) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return snackUseLocale(componentName);
}